








import Vue from 'vue';
import UiNotifications from '@/components/ui/UiNotifications/UiNotification.vue';
import { mapActions, mapGetters, mapMutations } from 'vuex';

const Components = {
  AppTemplate: () => import('@/templates/AppTemplate.vue'),
  AuthTemplate: () => import('@/templates/AuthTemplate.vue'),
};

export default Vue.extend({
  name: 'MainApp',
  components: {
    ...Components,
    UiNotifications,
  },
  async mounted() {
    if (!this.accessToken) {
      return;
    }

    const { count } = await this.getNotifications();
    await this.getNotifications({ limit: count, offset: 0 });
  },
  computed: {
    templateComponent() {
      const defaultTemplateName = 'AppTemplate';
      const checkComponentExist = (templateName: string): boolean => Object.keys(Components).includes(templateName);
      const templateName = this.$route.meta.template || defaultTemplateName;
      return checkComponentExist(templateName) ? templateName : defaultTemplateName;
    },
    ...mapGetters(['accessToken']),
  },
  methods: {
    ...mapActions(['getNotifications']),
    ...mapMutations(['setNotifications']),
  },
});
